export default __webpack_public_path__ + "static/media/displayer_cadefi.0b002a20.png";